// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { apiKeySchema } from '@/account/api/types';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

const responseSchema = z
  .object({
    data: z.array(apiKeySchema),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, keys: data }));

/**
 * Requests a list of API keys for the given organization from the remote API.
 *
 * @param key - The key of the organization for which to request configurations.
 */
export async function getAPIKeys(key: string) {
  const path = `/v1/organization/${key}/api-key`;
  const response = await api.get(path);

  return parseResponse(responseSchema, response.data, {
    schemaName: 'APIKeys',
    endpoint: path,
  });
}
